export default state => state.savedItems.notificationsOptInBucket;
